export class Bonus {
    /**
     * (RO) Jedinecna identifikace bonusu
     */
    get uid(): number { return this._uid; }
    private _uid: number;

    /**
     * (RO) Delka platnosti bonusu v ms
     */
    get duration(): number { return this._duration; }
    private _duration: number;

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    constructor(uid: number, duration: number) {
        this._uid = uid;
        this._duration = duration * 1000;
    }
}



export const enum eBonusUID {
    shield,
    scoreMultiplier,
}



export const BONUSES: Bonus[] = [
    new Bonus(eBonusUID.shield, 8),
    new Bonus(eBonusUID.scoreMultiplier, 16),
]